import { API, ProjectAPI } from '@brg/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  CREATIVE_BU_TAG_ID,
  VISUAL_RES_TAG_ID_BL,
  MODERN_ART_TAG_ID,
  CITIES_TAG_ID,
  BASIC_DESIGN_COURSE_TAG_ID,
  HOLIDAYS_TAG_ID,
  ILLUSTRATED_BOOK_TAG_ID,
  ANIMATION_TAG_ID,
  COMICS_TAG_ID,
  VIMMELBUH_ID,
  PICTURE_BOOK_ID,
  INFOGRAPHICS_TAG_ID,
  ILLUSTRATION_TAG_ID,
  CONTEMPORARY_ART_TAG_ID,
  PHOTOBOOK_TAG_ID,
  TYPE_TAG_ID,
  TYPOGRAPHY_TAG_ID,
  TD_ENVIRONMENT_TAG_ID,
  TD_ART_TAG_ID,
  DULYOVO_PORCELAIN_TAG_ID,
  PRINTED_GRAPHICS_TAG_ID,
  ART_OBJECT_TAG_ID,
  CHILD_BOOK_ID,
  BOOK_DESIGN_ID,
  COMMUNICATION_TAG_ID,
  EXHIBITION_SPACE_TAG_ID,
  SCULPTURE_TAG_ID,
  PERFORMANS_ID,
  PHOTOGRAPHY_ART_TAG_ID,
  INSTALLATION_TAG_ID,
  ABSTRACT_EXPRESSIONISM_TAG_ID,
  HSECOLLECTION_TEXTILE_TAG_ID,
  DDD_POST_PROD_TAG_ID,
  EDUCATION_COURSE,
} from 'shared/constants/misc';

//const PROJECTS_COUNT_FOR_OFFSET = 20;
const PROJECTS_COUNT_START_OFFSET = 0;

type Tabs = {
  [key: string]: string[] | string | null;
}

const calcOffsetValue = (page: number, count: number) => {
  return page <= count ? page : count;
}

export const slicedKey = <T>(key: keyof T, filter:T, mode?: string): any => {
  const res = { ...filter};
  if (mode === 'delete') {
    if (Array.isArray(key)) {
      let r = {};
      for (let prop in key) {
        //@ts-ignore
        if(res.hasOwnProperty(key[prop]) ) {
          //@ts-ignore
          delete res[key[prop]]
          // @ts-ignore
          r = {...res};
        }
      }
      return r;
    } 
    delete res[key];
    return res;
  }
  return res[key];
}


const exceptionParamForEmptyTab = (filter: any, ctxName: string) => {
  const res = {...filter};

  if ((["ailab", 'artsandcrafts', 'hseposterlab', 'hsephotolab', 'hsemultimedia'].includes(ctxName))) {
    const newRes = {
      ...res,
      contexts: ['hsedesign'],
    }
    return newRes;
  }

  if ((ctxName === "hsefonts")) {
    const newRes = {
      ...res,
      contexts: ['hsedesign', 'hsefonts'],
    }
    return newRes;
  }

  if (ctxName === "hsevisualresearch") {
    const newRes = {
      ...res,
    }
    //@ts-ignore
    return slicedKey([ 'tagIds', 'isContextIgnored'], newRes, 'delete');
  }
  if (ctxName === "main_geo") {
    const newRes = {
      ...res,
      isContextIgnored: false,
      contexts: ['hsevisualresearch'],
    }
    //@ts-ignore
    return slicedKey(['isFilterReplaceTags'], newRes, 'delete');
  }
  if (ctxName === "sound_deziiign") {
    const newRes = {
      ...res,
      contexts: ['hsesoundlabel'],
    }
    //@ts-ignore
    return slicedKey(['isFilterReplaceTags', 'globalTypes', 'tagIds'], newRes, 'delete');
  }

  return res
}

const exceptionParam = (filter: any, tagList: any, ctxName: string) => {
  const res = { ...filter};
  
  if (["ailab", 'artsandcrafts', 'hsephotolab'].includes(ctxName)) {
    const newRes = {
      ...res,
      contexts: ['hsedesign'],
    }
    //@ts-ignore
    return slicedKey(['tagIds'], newRes, 'delete');
  }

  if (['hseposterlab'].includes(ctxName)) {
    const newRes = {
      ...res,
      contexts: ['hsedesign'],
    }
    return newRes;
  }

  if (ctxName === "research") {
    if (tagList.includes(EDUCATION_COURSE)) {
      //@ts-ignore
      return slicedKey(['requiredTagIds'], res, 'delete');
    }
  }

  if (ctxName === "hsevisualresearch") {
    if (!tagList) {
      //@ts-ignore
      return slicedKey(['tagIds', 'isContextIgnored'], res, 'delete');
    }
    if (tagList.includes(EDUCATION_COURSE)) {
      //@ts-ignore
      return slicedKey(['requiredTagIds', 'isContextIgnored'], res, 'delete');
    }

    //@ts-ignore
    return slicedKey(['isContextIgnored'], res, 'delete');
  }

  if (['hsemultimedia'].includes(ctxName)) {
    const newRes = {
      ...res,
      contexts: ['hsedesign'],
    }

    if (tagList?.includes(DDD_POST_PROD_TAG_ID)) {
      //@ts-ignore
      return slicedKey(['requiredTagIds'], newRes, 'delete');
    }
    return newRes
  }

  if ((ctxName === "hsefonts")) {
    const newRes = {
      ...res,
      contexts: ['hsedesign', 'hsefonts'],
    }
    //@ts-ignore
    return slicedKey(['tagIds'], newRes, 'delete');
  }
  if (ctxName === "research" && !tagList) {
    const newRes = {
      ...res,
    }
    //@ts-ignore
    return slicedKey(['tagIds'], newRes, 'delete');
  }
  if (["main_geo", "media_geo"].includes(ctxName) && tagList?.includes(VISUAL_RES_TAG_ID_BL)) {
    const newRes = {
      ...res,
      hasGeoTag: true,
      mainPage: false,
    }
    //@ts-ignore
    return slicedKey(['isFilterReplaceTags'], newRes, 'delete');
  }
  if(ctxName === 'hsemanagement' || ctxName === 'hsestartup') {

    if (tagList?.includes(CREATIVE_BU_TAG_ID) || tagList?.includes(BASIC_DESIGN_COURSE_TAG_ID)) {
      const newRes = {
        ...res,
        mainPage: false,
      }
      //@ts-ignore
      return slicedKey(['requiredTagIds', 'contexts'], newRes, 'delete')
    }
  }
  if(ctxName === "creative_geo" && tagList?.includes(HOLIDAYS_TAG_ID)) {
    const newRes = {
      ...res,
      hascities: true,
      hasgeoplaces: true
    }
    return newRes;
  }

  if (ctxName === 'hse-illustration') {
    if (tagList?.includes(ILLUSTRATION_TAG_ID)) {
      const newRes = {
        ...res,
        exceptedTagIds: [
          ILLUSTRATED_BOOK_TAG_ID,
          ANIMATION_TAG_ID,
          COMICS_TAG_ID,
          VIMMELBUH_ID,
          PICTURE_BOOK_ID,
          INFOGRAPHICS_TAG_ID,
          CHILD_BOOK_ID,
          EXHIBITION_SPACE_TAG_ID,
          SCULPTURE_TAG_ID,
          PERFORMANS_ID,
          INSTALLATION_TAG_ID,
          ABSTRACT_EXPRESSIONISM_TAG_ID,
        ]
      }
      return newRes;
    }
    if (tagList?.includes(COMICS_TAG_ID)) {
      const newRes = {
        ...res,
        exceptedTagIds: [
          ILLUSTRATED_BOOK_TAG_ID,
          VIMMELBUH_ID,
          PICTURE_BOOK_ID,
          INFOGRAPHICS_TAG_ID,
          SCULPTURE_TAG_ID,
          HSECOLLECTION_TEXTILE_TAG_ID
        ]
      }
      return newRes;
    }
    if (tagList?.includes(ILLUSTRATED_BOOK_TAG_ID)) {
      const newRes = {
        ...res,
        exceptedTagIds: [
          PHOTOGRAPHY_ART_TAG_ID,
          COMICS_TAG_ID,
          CONTEMPORARY_ART_TAG_ID,
          PHOTOBOOK_TAG_ID,
          TYPE_TAG_ID,
          TYPOGRAPHY_TAG_ID,
          TD_ENVIRONMENT_TAG_ID,
          TD_ART_TAG_ID,
          DULYOVO_PORCELAIN_TAG_ID,
          PRINTED_GRAPHICS_TAG_ID,
          ART_OBJECT_TAG_ID,
          BOOK_DESIGN_ID,
          COMMUNICATION_TAG_ID,
        ]
      }
      return newRes;
    }
  }

  if((ctxName === "creative_geo" || ctxName === 'academy_geo') && tagList?.includes(CITIES_TAG_ID)) {
    const newRes = {
      ...res,
      //ТЕГИ ИСКЛЮЧЕНИЯ ДЛЯ КРЕАТИВНОГО ГОРОДА TEST @Artem
      // exceptedTagIds: [
      //   'db9d4954c3354147b496d8098b1cc096',
      //   'b0b2ee60d6654ed7958c76af78f36b56',
      //   'c1e7071d86004544a497fd305b38550d',
      //   '51069562a18341c2a968889727034174',
      //   '8db18d7413d74ab7a8e7aac29cfa3b25',
      //   '80f8067e3db745d3985740ccc30d3d5a',
      //   'd85cb74227a841998fa2aa18843ad35b',
      //   '977b986e706b46ff9e8b809c700a9c5d',
      //   '5c0e423eed054a5b9970c54d1d9796fd',
      //   '3d51f447146549d5b138dbf0fcdca198',
      //   'de086b71f91b47fbab5b4e4c3a6ee311',
      //   '4e9f6f2a028e469893306a9c3e58c539',
      //   '4a2f0bd881284e9caa56df4d19432d0e',
      // ]
    }
    return newRes;
  }
  if ((ctxName === "art_geo" || ctxName === 'art_deziiign') && tagList?.includes('null')) {
    const newRes = {
      ...res,
      isContextIgnored: false,
      contexts: ['hsegallery'],
    }
    //@ts-ignore
    return slicedKey(['tagIds'], newRes, 'delete');
  }

  if (ctxName === "art_geo" && tagList?.includes(MODERN_ART_TAG_ID)) {
    const newRes = {
      ...res,
      isContextIgnored: false,
    }
    return newRes
  }
  if (ctxName === "main_geo" && tagList?.includes('geo_all')) {
    const newRes = {
      ...res,
      hasGeoTag: true,
    }
    //@ts-ignore
    return slicedKey(['isFilterReplaceTags', 'tagIds'], newRes, 'delete');
  }

  if (ctxName === "hsecreative" && tagList.includes(CREATIVE_BU_TAG_ID)) {
    //@ts-ignore
    return slicedKey(['contexts', 'isFilterReplaceTags'], res, 'delete');
  }
  
  if (ctxName === "dpo") {
    
    const newRes = {
      ...res,
    }
    
    //@ts-ignore
    return slicedKey(['tagIds'], newRes, 'delete');
  }

  return res;
}


const setParam = (arr: any, filter: any, ctxName: string) => (
  arr.map((i: any) => {
    if (i === null) {
      //@ts-ignore
      const tagDeleteFn = ({ tagIds, ...rest }) => rest
      const serializeFilter = tagDeleteFn(filter)

      return {
        ...exceptionParamForEmptyTab(serializeFilter, ctxName),
        offset: PROJECTS_COUNT_START_OFFSET
      }
    }

    const tagIds = (i?.includes('geo_all') || i?.includes('null')) ? {} : { tagIds: i }

    return {
      ...exceptionParam(filter, i, ctxName),
      offset: PROJECTS_COUNT_START_OFFSET,
      ...tagIds
    }
  })
)

export const fetchInfiniteProjects = createAsyncThunk(
  'projects/fetchInfiniteProjects',
  async (args: any, { getState }: { getState: any }) => {
    const { preload, page, lang, exceptionLoad } = args;
    const { filter, preloadData } = getState().projects;

    const json = Promise.all(
      preload.map((i: Tabs) => {
        const ctxName = slicedKey('contextName', i )
        const slicedCtxName = slicedKey('contextName', i, 'delete' );

        const serializeFilter = setParam(Object.values(slicedCtxName), filter, ctxName )[0]

        return (
          ProjectAPI.GetMainPage({
            ...serializeFilter
          }).then((d) => d.json())
            .then((d) => lang ? (API.lang(d, lang) as any) : d)
        )
      }))
      .then((res: any) => {
          return {
            //@ts-ignore
            all: Object.assign(...res?.map((n: any, i: any) => ({ [Object.keys(preload[i])[0]]: n?.data }))),
            //@ts-ignore
            paging: res[0].paging,
            //@ts-ignore
            isFinalPage: res[0]?.paging?.pages <= res[0]?.paging?.page,
            //@ts-ignore
            pagingAll: Object.assign(...res?.map((n: any, i: any) => ({ [Object.keys(preload[i])[0]]: n?.paging }))),
            context: filter.requestContext,
          }
        }
      )

    return json;
  }
);

export const fetchInfiniteProjectsMore = createAsyncThunk(
  'projects/fetchInfiniteProjectsMore',
  async (args: any, { getState }: { getState: any }) => {
    const { lang, page, exceptions, tabs, contextName, withoutTabs } = args;
    const { filter, paging } = getState().projects;
    const currentState = getState().projects.data;

    const tagIds = tabs.filter((i: Tabs) => {
      return JSON.stringify(Object.values(i)[0]) === JSON.stringify(filter?.tagIds)
    })[0]

    const inNotEmptyTab = filter.hasOwnProperty('tagIds') && (!!tagIds && !!Object.keys(tagIds)?.length);

    const param = withoutTabs ? filter : inNotEmptyTab ? exceptionParam(filter, Object.values(tagIds)[0], contextName) :  exceptionParamForEmptyTab(filter, contextName)

    const json = await API.Json(
      ProjectAPI.GetMainPage({
        ...param,
        offset: (paging.offset === 0 && page) ? (exceptions ? PROJECTS_COUNT_START_OFFSET : (Number(page) * filter.limit)) : paging.offset + filter.limit
      }),
    )

    return lang ? (API.lang({
        paging: { ...json.paging },
        data: [...currentState, ...json.data],
          //@ts-ignore
        isFinalPage: json.paging.pages <= json?.paging?.page
        }, lang) as any)
      : {
        paging: json.paging,
        data: [...currentState, ...json.data],
          //@ts-ignore
        isFinalPage: json.paging.pages <= json?.paging?.page
      };
  }
);

export const fetchInfiniteProjectsWithUpdate = createAsyncThunk(
  'projects/fetchInfiniteProjectsWithUpdate',
  async (args: any, { getState }: { getState: any }) => {
    const { page, lang } = args;
    const { filter, paging } = getState().projects;

    const json = await API.Json(
      ProjectAPI.GetMainPage({
        ...filter,
        offset: calcOffsetValue(
          (Number(page) * filter.limit
          ),
          paging?.count
        ) - filter.limit
      }),
    )
    return lang ? (API.lang({
      paging: json.paging,
      data: [...json.data],
      //@ts-ignore
      isFinalPage: json.paging.pages <= json?.paging?.page
    }, lang) as any) : {
      paging: json.paging,
      data: [...json.data],
      //@ts-ignore
      isFinalPage: json.paging.pages <= json?.paging?.page
    };
  }
);
import { API, ProjectAPI } from '@brg/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  CREATIVE_BU_TAG_ID,
  VISUAL_RES_TAG_ID_BL,
  MODERN_ART_TAG_ID,
  CITIES_TAG_ID,
  BASIC_DESIGN_COURSE_TAG_ID,
  HOLIDAYS_TAG_ID,
  ILLUSTRATED_BOOK_TAG_ID,
  ANIMATION_TAG_ID,
  COMICS_TAG_ID,
  VIMMELBUH_ID,
  PICTURE_BOOK_ID,
  INFOGRAPHICS_TAG_ID,
  ILLUSTRATION_TAG_ID,
  CONTEMPORARY_ART_TAG_ID,
  PHOTOBOOK_TAG_ID,
  TYPE_TAG_ID,
  TYPOGRAPHY_TAG_ID,
  TD_ENVIRONMENT_TAG_ID,
  TD_ART_TAG_ID,
  DULYOVO_PORCELAIN_TAG_ID,
  PRINTED_GRAPHICS_TAG_ID,
  ART_OBJECT_TAG_ID,
  CHILD_BOOK_ID,
  BOOK_DESIGN_ID,
  COMMUNICATION_TAG_ID,
  EXHIBITION_SPACE_TAG_ID,
  SCULPTURE_TAG_ID,
  PERFORMANS_ID,
  PHOTOGRAPHY_ART_TAG_ID,
  INSTALLATION_TAG_ID,
  ABSTRACT_EXPRESSIONISM_TAG_ID,
  HSECOLLECTION_TEXTILE_TAG_ID,
  DDD_POST_PROD_TAG_ID,
  EDUCATION_COURSE,
} from 'shared/constants/misc';

//const PROJECTS_COUNT_FOR_OFFSET = 20;
const PROJECTS_COUNT_START_OFFSET = 0;

type Tabs = {
  [key: string]: string[] | string | null;
}

const calcOffsetValue = (page: number, count: number) => {
  return page <= count ? page : count;
}

export const slicedKey = <T>(key: keyof T, filter:T, mode?: string): any => {
  const res = { ...filter};
  if (mode === 'delete') {
    if (Array.isArray(key)) {
      let r = {};
      for (let prop in key) {
        //@ts-ignore
        if(res.hasOwnProperty(key[prop]) ) {
          //@ts-ignore
          delete res[key[prop]]
          // @ts-ignore
          r = {...res};
        }
      }
      return r;
    } 
    delete res[key];
    return res;
  }
  return res[key];
}


const exceptionParamForEmptyTab = (filter: any, ctxName: string) => {
  const res = {...filter};

  if ((["ailab", 'artsandcrafts', 'hseposterlab', 'hsephotolab', 'hsemultimedia'].includes(ctxName))) {
    const newRes = {
      ...res,
      contexts: ['hsedesign'],
    }
    return newRes;
  }

  if ((ctxName === "hsefonts")) {
    const newRes = {
      ...res,
      contexts: ['hsedesign', 'hsefonts'],
    }
    return newRes;
  }

  if (ctxName === "hsevisualresearch") {
    const newRes = {
      ...res,
    }
    //@ts-ignore
    return slicedKey([ 'tagIds', 'isContextIgnored'], newRes, 'delete');
  }
  if (ctxName === "main_geo") {
    const newRes = {
      ...res,
      isContextIgnored: false,
      contexts: ['hsevisualresearch'],
    }
    //@ts-ignore
    return slicedKey(['isFilterReplaceTags'], newRes, 'delete');
  }
  if (ctxName === "sound_deziiign") {
    const newRes = {
      ...res,
      contexts: ['hsesoundlabel'],
    }
    //@ts-ignore
    return slicedKey(['isFilterReplaceTags', 'globalTypes', 'tagIds'], newRes, 'delete');
  }

  return res
}

const exceptionParam = (filter: any, tagList: any, ctxName: string) => {
  const res = { ...filter};
  
  if (["ailab", 'artsandcrafts', 'hsephotolab'].includes(ctxName)) {
    const newRes = {
      ...res,
      contexts: ['hsedesign'],
    }
    //@ts-ignore
    return slicedKey(['tagIds'], newRes, 'delete');
  }

  if (['hseposterlab'].includes(ctxName)) {
    const newRes = {
      ...res,
      contexts: ['hsedesign'],
    }
    return newRes;
  }

  if (ctxName === "research") {
    if (tagList.includes(EDUCATION_COURSE)) {
      //@ts-ignore
      return slicedKey(['requiredTagIds'], res, 'delete');
    }
  }

  if (ctxName === "hsevisualresearch") {
    if (!tagList) {
      //@ts-ignore
      return slicedKey(['tagIds', 'isContextIgnored'], res, 'delete');
    }
    if (tagList.includes(EDUCATION_COURSE)) {
      //@ts-ignore
      return slicedKey(['requiredTagIds', 'isContextIgnored'], res, 'delete');
    }

    //@ts-ignore
    return slicedKey(['isContextIgnored'], res, 'delete');
  }

  if (['hsemultimedia'].includes(ctxName)) {
    const newRes = {
      ...res,
      contexts: ['hsedesign'],
    }

    if (tagList?.includes(DDD_POST_PROD_TAG_ID)) {
      //@ts-ignore
      return slicedKey(['requiredTagIds'], newRes, 'delete');
    }
    return newRes
  }

  if ((ctxName === "hsefonts")) {
    const newRes = {
      ...res,
      contexts: ['hsedesign', 'hsefonts'],
    }
    //@ts-ignore
    return slicedKey(['tagIds'], newRes, 'delete');
  }
  if (ctxName === "research" && !tagList) {
    const newRes = {
      ...res,
    }
    //@ts-ignore
    return slicedKey(['tagIds'], newRes, 'delete');
  }
  if (["main_geo", "media_geo"].includes(ctxName) && tagList?.includes(VISUAL_RES_TAG_ID_BL)) {
    const newRes = {
      ...res,
      hasGeoTag: true,
      mainPage: false,
    }
    //@ts-ignore
    return slicedKey(['isFilterReplaceTags'], newRes, 'delete');
  }
  if(ctxName === 'hsemanagement' || ctxName === 'hsestartup') {

    if (tagList?.includes(CREATIVE_BU_TAG_ID) || tagList?.includes(BASIC_DESIGN_COURSE_TAG_ID)) {
      const newRes = {
        ...res,
        mainPage: false,
      }
      //@ts-ignore
      return slicedKey(['requiredTagIds', 'contexts'], newRes, 'delete')
    }
  }
  if(ctxName === "creative_geo" && tagList?.includes(HOLIDAYS_TAG_ID)) {
    const newRes = {
      ...res,
      hascities: true,
      hasgeoplaces: true
    }
    return newRes;
  }

  if (ctxName === 'hse-illustration') {
    if (tagList?.includes(ILLUSTRATION_TAG_ID)) {
      const newRes = {
        ...res,
        exceptedTagIds: [
          ILLUSTRATED_BOOK_TAG_ID,
          ANIMATION_TAG_ID,
          COMICS_TAG_ID,
          VIMMELBUH_ID,
          PICTURE_BOOK_ID,
          INFOGRAPHICS_TAG_ID,
          CHILD_BOOK_ID,
          EXHIBITION_SPACE_TAG_ID,
          SCULPTURE_TAG_ID,
          PERFORMANS_ID,
          INSTALLATION_TAG_ID,
          ABSTRACT_EXPRESSIONISM_TAG_ID,
        ]
      }
      return newRes;
    }
    if (tagList?.includes(COMICS_TAG_ID)) {
      const newRes = {
        ...res,
        exceptedTagIds: [
          ILLUSTRATED_BOOK_TAG_ID,
          VIMMELBUH_ID,
          PICTURE_BOOK_ID,
          INFOGRAPHICS_TAG_ID,
          SCULPTURE_TAG_ID,
          HSECOLLECTION_TEXTILE_TAG_ID
        ]
      }
      return newRes;
    }
    if (tagList?.includes(ILLUSTRATED_BOOK_TAG_ID)) {
      const newRes = {
        ...res,
        exceptedTagIds: [
          PHOTOGRAPHY_ART_TAG_ID,
          COMICS_TAG_ID,
          CONTEMPORARY_ART_TAG_ID,
          PHOTOBOOK_TAG_ID,
          TYPE_TAG_ID,
          TYPOGRAPHY_TAG_ID,
          TD_ENVIRONMENT_TAG_ID,
          TD_ART_TAG_ID,
          DULYOVO_PORCELAIN_TAG_ID,
          PRINTED_GRAPHICS_TAG_ID,
          ART_OBJECT_TAG_ID,
          BOOK_DESIGN_ID,
          COMMUNICATION_TAG_ID,
        ]
      }
      return newRes;
    }
  }

  if((ctxName === "creative_geo" || ctxName === 'academy_geo') && tagList?.includes(CITIES_TAG_ID)) {
    const newRes = {
      ...res,
      //ТЕГИ ИСКЛЮЧЕНИЯ ДЛЯ КРЕАТИВНОГО ГОРОДА TEST @Artem
      // exceptedTagIds: [
      //   'db9d4954c3354147b496d8098b1cc096',
      //   'b0b2ee60d6654ed7958c76af78f36b56',
      //   'c1e7071d86004544a497fd305b38550d',
      //   '51069562a18341c2a968889727034174',
      //   '8db18d7413d74ab7a8e7aac29cfa3b25',
      //   '80f8067e3db745d3985740ccc30d3d5a',
      //   'd85cb74227a841998fa2aa18843ad35b',
      //   '977b986e706b46ff9e8b809c700a9c5d',
      //   '5c0e423eed054a5b9970c54d1d9796fd',
      //   '3d51f447146549d5b138dbf0fcdca198',
      //   'de086b71f91b47fbab5b4e4c3a6ee311',
      //   '4e9f6f2a028e469893306a9c3e58c539',
      //   '4a2f0bd881284e9caa56df4d19432d0e',
      // ]
    }
    return newRes;
  }
  if ((ctxName === "art_geo" || ctxName === 'art_deziiign') && tagList?.includes('null')) {
    const newRes = {
      ...res,
      isContextIgnored: false,
      contexts: ['hsegallery'],
    }
    //@ts-ignore
    return slicedKey(['tagIds'], newRes, 'delete');
  }

  if (ctxName === "art_geo" && tagList?.includes(MODERN_ART_TAG_ID)) {
    const newRes = {
      ...res,
      isContextIgnored: false,
    }
    return newRes
  }
  if (ctxName === "main_geo" && tagList?.includes('geo_all')) {
    const newRes = {
      ...res,
      hasGeoTag: true,
    }
    //@ts-ignore
    return slicedKey(['isFilterReplaceTags', 'tagIds'], newRes, 'delete');
  }

  if (ctxName === "hsecreative" && tagList.includes(CREATIVE_BU_TAG_ID)) {
    //@ts-ignore
    return slicedKey(['contexts', 'isFilterReplaceTags'], res, 'delete');
  }
  
  if (ctxName === "dpo") {
    
    const newRes = {
      ...res,
    }
    
    //@ts-ignore
    return slicedKey(['tagIds'], newRes, 'delete');
  }

  return res;
}


const setParam = (arr: any, filter: any, ctxName: string) => (
  arr.map((i: any) => {
    if (i === null) {
      //@ts-ignore
      const tagDeleteFn = ({ tagIds, ...rest }) => rest
      const serializeFilter = tagDeleteFn(filter)

      return {
        ...exceptionParamForEmptyTab(serializeFilter, ctxName),
        offset: PROJECTS_COUNT_START_OFFSET
      }
    }

    const tagIds = (i?.includes('geo_all') || i?.includes('null')) ? {} : { tagIds: i }

    return {
      ...exceptionParam(filter, i, ctxName),
      offset: PROJECTS_COUNT_START_OFFSET,
      ...tagIds
    }
  })
)

export const fetchInfiniteProjects = createAsyncThunk(
  'projects/fetchInfiniteProjects',
  async (args: any, { getState }: { getState: any }) => {
    const { preload, page, lang, exceptionLoad } = args;
    const { filter, preloadData } = getState().projects;

    const json = Promise.all(
      preload.map((i: Tabs) => {
        const ctxName = slicedKey('contextName', i )
        const slicedCtxName = slicedKey('contextName', i, 'delete' );

        const serializeFilter = setParam(Object.values(slicedCtxName), filter, ctxName )[0]

        return (
          ProjectAPI.GetMainPage({
            ...serializeFilter
          }).then((d) => d.json())
            .then((d) => lang ? (API.lang(d, lang) as any) : d)
        )
      }))
      .then((res: any) => {
          return {
            //@ts-ignore
            all: Object.assign(...res?.map((n: any, i: any) => ({ [Object.keys(preload[i])[0]]: n?.data }))),
            //@ts-ignore
            paging: res[0].paging,
            //@ts-ignore
            isFinalPage: res[0]?.paging?.pages <= res[0]?.paging?.page,
            //@ts-ignore
            pagingAll: Object.assign(...res?.map((n: any, i: any) => ({ [Object.keys(preload[i])[0]]: n?.paging }))),
            context: filter.requestContext,
          }
        }
      )

    return json;
  }
);

export const fetchInfiniteProjectsMore = createAsyncThunk(
  'projects/fetchInfiniteProjectsMore',
  async (args: any, { getState }: { getState: any }) => {
    const { lang, page, exceptions, tabs, contextName, withoutTabs } = args;
    const { filter, paging } = getState().projects;
    const currentState = getState().projects.data;

    const tagIds = tabs.filter((i: Tabs) => {
      return JSON.stringify(Object.values(i)[0]) === JSON.stringify(filter?.tagIds)
    })[0]

    const inNotEmptyTab = filter.hasOwnProperty('tagIds') && (!!tagIds && !!Object.keys(tagIds)?.length);

    const param = withoutTabs ? filter : inNotEmptyTab ? exceptionParam(filter, Object.values(tagIds)[0], contextName) :  exceptionParamForEmptyTab(filter, contextName)

    const json = await API.Json(
      ProjectAPI.GetMainPage({
        ...param,
        offset: (paging.offset === 0 && page) ? (exceptions ? PROJECTS_COUNT_START_OFFSET : (Number(page) * filter.limit)) : paging.offset + filter.limit
      }),
    )

    return lang ? (API.lang({
        paging: { ...json.paging },
        data: [...currentState, ...json.data],
          //@ts-ignore
        isFinalPage: json.paging.pages <= json?.paging?.page
        }, lang) as any)
      : {
        paging: json.paging,
        data: [...currentState, ...json.data],
          //@ts-ignore
        isFinalPage: json.paging.pages <= json?.paging?.page
      };
  }
);

export const fetchInfiniteProjectsWithUpdate = createAsyncThunk(
  'projects/fetchInfiniteProjectsWithUpdate',
  async (args: any, { getState }: { getState: any }) => {
    const { page, lang } = args;
    const { filter, paging } = getState().projects;

    const json = await API.Json(
      ProjectAPI.GetMainPage({
        ...filter,
        offset: calcOffsetValue(
          (Number(page) * filter.limit
          ),
          paging?.count
        ) - filter.limit
      }),
    )
    return lang ? (API.lang({
      paging: json.paging,
      data: [...json.data],
      //@ts-ignore
      isFinalPage: json.paging.pages <= json?.paging?.page
    }, lang) as any) : {
      paging: json.paging,
      data: [...json.data],
      //@ts-ignore
      isFinalPage: json.paging.pages <= json?.paging?.page
    };
  }
);
